import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import { container } from '@Container';
import { BookAction } from '@Redux/actions';
import { TYPES } from '@Types';
import { BuildStatus } from '@Models';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

const BookBuildComponent: React.FC<Props> = ({ isLoading, book, cancel, toBuild }) => {
  return (
    <div className="mt-2 text-center">
      <h1><FormattedMessage id={'publication.book.build.form.title'} /></h1>
      {!isLoading &&
        book != null && (
          <>
            {book.buildStatus === BuildStatus.Built && (
              <div className="" role="">
                Book built at {book.buildAt?.toLocaleString()}.
                Available at <a href={book.buildUrl!}>Download</a>
              </div>
            )}
            {book.buildStatus === BuildStatus.Building && (
              <div className="" role="">
                Processing building the book...
              </div>
            )}
            {book.buildStatus === BuildStatus.Failed && (
              <div className="" role="">
                Last build failed as {book.buildAt?.toLocaleString()}
              </div>
            )}
            {book.buildStatus === BuildStatus.NotBuilt && (
              <div className="" role="">
                No built have be done for this book.
              </div>
            )}
            <div className="action">
            <button className="btn btn-age" type="button" onClick={() => cancel()}><FormattedMessage {...defaultMessages.formCancel} /></button>
              <button className="btn btn-age" type="button" onClick={() => toBuild(book.id)}>
                <i className="fa-solid fa-gears" aria-hidden="true" /> <FormattedMessage {...defaultMessages.formBuild} />
              </button>
            </div>
          </>
        )}
    </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  isLoading: state.book.isLoading,
  book: {
    id: state.book.entity?.id ?? '',
    name: state.book.entity?.name ?? '',
    buildAt: state.book.entity?.buildAt ?? null,
    buildUrl: state.book.entity?.buildUrl ?? null,
    buildStatus: state.book.entity?.buildStatus ?? null
  }
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const bookAction = container.get<BookAction>(TYPES.Actions.Publication.BookAction);
  return {
    cancel: () => dispatch(bookAction.cancel()),
    toBuild: (bookId: string) => dispatch(bookAction.build(bookId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BookBuildComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
